require.register("app/product/stat/AverageMarginView", function(exports, require, module){
  $0
  
});

